// Returns the raw cookie value — no decodeURIComponent, unlike angular's $browser.cookies().
// Cookies written with encodeURIComponent come back percent-encoded.
export const getCookie = (name: string) => document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))?.[2];

// Cookies in this app are written on `path=/`, so that is the default. A cookie can only be
// removed on the path and domain it was written with, and the removal fails silently on a
// mismatch — a cookie written on `.upsales.com` survives a host-only removal.
export const removeCookie = (name: string, path = '/', domain?: string) => {
	const domainPart = domain ? `;domain=${domain}` : '';
	document.cookie = `${name}=;path=${path}${domainPart};expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
